import React from 'react';
import { IPermission } from '../../../../@types/employee';
import RoleTreeView from '../../../customComponents/tree/RoleTreeView';

interface IUserRightsDialogProps {
    permissions : IPermission;

    onChange : (permissions : IPermission) => void;
}

interface IUserRightsDialogState {}

export default class UserRightsDialog extends React.PureComponent<IUserRightsDialogProps, IUserRightsDialogState> {
    constructor(props : IUserRightsDialogProps) {
        super(props);
        this.state = {};
    }

    public readonly render = () => {
        return (<RoleTreeView permissions={this.props.permissions} onPermissionChange={this.props.onChange} />);
    };
}
